import React from "react";
import type { ReactNode } from "react";

import { InsightsContextProvider } from "./App/Insights/contexts";
import { InsightsHubProvider } from "./App/InsightsHub/contexts/InsightsHubContext";
import { ProviderDirectoryContextProvider } from "./App/ProviderDirectory/contexts";

interface AppContextProviderProps {
  children: ReactNode;
}

export const AppContextProvider = ({ children }: AppContextProviderProps) => (
  <ProviderDirectoryContextProvider>
    <InsightsHubProvider>
      <InsightsContextProvider>{children}</InsightsContextProvider>
    </InsightsHubProvider>
  </ProviderDirectoryContextProvider>
);
